<!--
 * @Description:
 * @Version: 2.0
 * @Autor: sen.yang
 * @Date: 2021-12-01 20:28:02
 * @LastEditors: sen.yang
 * @LastEditTime: 2022-04-18 22:06:40
-->
<template>
	<div class="tree-select-row">
		<div class="tree-select-left" :style="grandson.length>0?'flex:.3':'flex:.8'">
			<div
				v-for="(item,index) in options"
				:key="index"
				class="tree-select-item van-ellipsis"
				:class="[
                {
                    'select':mainActiveIndex == index
                }
            ]"
				@click="selectPatren(index)"
			>
				{{item.name}}
			</div>
		</div>
		<div class="tree-select-mid" :style="grandson.length>0?'flex:.36':'flex:1'">
			<div
				v-for="(item,index) in children"
				:key="index"
				class="tree-select-item van-ellipsis"
				:class="[
                    {
                        'select':(showActive ? item.id === showActive : item.id === activeId)
                    }
                ]"
				@click="selectSon(item)"
			>
				{{item.name}}
				<div v-if="item.id === activeId && grandson.length==0" class="select-icon"
					><van-icon name="success"
				/></div>
			</div>
		</div>
		<div class="tree-select-right" :style="grandson.length>0?'flex:.34':'flex:0'">
			<div
				v-for="(item,index) in grandson"
				:key="index"
				class="tree-select-item van-ellipsis"
				:class="[
                    {
                        'select':item.id === activeId
                    }
                ]"
				@click="selectGrandSon(item)"
			>
				{{item.name}}
				<div v-if="item.id === activeId" class="select-icon"><van-icon name="success" /></div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
    props: {
        options: {
            type: Array,
            default: () => []
        },
        mainActiveIndex: {
            type: [String, Number],
            default: 0
        },
        activeId: {
            type: [String, Number],
            default: 0
        }
    },
    data () {
        return {
            grandson: [],
            showActive: '',
        }
    },
    computed: {
        children () {
            return this.options[this.mainActiveIndex].children || []
        },
    },
    created () {

    },
    methods: {
        selectPatren (index) {
            this.grandson = []
            this.$emit('update:mainActiveIndex', index)
            this.showActive = ''
            if (this.options[index].children.length > 0) {
                this.$emit('update:activeId', this.options[index].children[0].id)
            }
        },
        selectSon (item) {
            this.grandson = []
            this.showActive = ''
            console.log(item)
            if (item.children && item.children.length > 0) {
                this.showActive = item.id
                this.grandson = item.children
            } else {
                this.$emit('update:activeId', item.id)
                this.$emit('change', item)
            }
        },
        selectGrandSon (item) {
            this.$emit('update:activeId', item.id)
            this.$emit('change', item)
        }
    }
}
</script>

<style scoped>
.tree-select-row {
	display: flex;
	height: 100%;
}
.tree-select-left {
	flex: 0.3;
	height: 100%;
	background-color: #f7f7f7;
	overflow: hidden;
	overflow-y: scroll;
	border-right: 1px solid #efefef;
}
.tree-select-row .select {
	background-color: #fff;
	color: #00bcd1;
}
.tree-select-mid {
	flex: 0.3;
	height: 100%;
	overflow: hidden;
	overflow-y: scroll;
	border-right: 1px solid #efefef;
}
.tree-select-right {
	flex: 0.4;
	height: 100%;
	overflow: hidden;
	overflow-y: scroll;
}
.tree-select-left::-webkit-scrollbar,
.tree-select-mid::-webkit-scrollbar,
.tree-select-right::-webkit-scrollbar {
	width: 0;
}

.tree-select-item {
	height: 14.6vw;
	line-height: 14.6vw;
	font-size: 4vw;
	color: #414141;
	padding: 0 4.2vw;
	/* width: 41.6vw;   */
	position: relative;
}
.select-icon {
	font-size: 3.3vw;
	color: #00bcd1;
	position: absolute;
	right: 4.2vw;
	top: 0;
}
</style>
